module.exports = __webpack_public_path__ + "media/images/room_monitor/drying-c2d10a7c379b566fd84f7087faea2cb3.gif";